// Node
const $ = require('jquery');

// Custom
import {CallbackWidget} from 'callback_widget';

$(function () {
  CallbackWidget.init('call-back');
});
